module.exports = __webpack_public_path__ + "static/img/brain.e95e55c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/brain.svg
// module id = qJj+
// module chunks = 1